import { type FC, type PropsWithChildren } from "react";
import {
  closeSnackbar,
  SnackbarProvider as SnackbarClientProvider,
} from "notistack";
import { IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

export const SnackbarProvider: FC<PropsWithChildren> = ({ children }) => {
  return (
    <SnackbarClientProvider
      maxSnack={1}
      anchorOrigin={{
        vertical: "top",
        horizontal: "center",
      }}
      autoHideDuration={2000}
      action={(snackbarId) => (
        <IconButton size="small" onClick={() => closeSnackbar(snackbarId)}>
          <CloseIcon />
        </IconButton>
      )}
    >
      {children}
    </SnackbarClientProvider>
  );
};
